// extracted by mini-css-extract-plugin
export var cardHeader = "_iy-1";
export var contentCard = "_iy-0";
export var headerActions = "_iy-3";
export var reorderHandle = "_iy-5";
export var titleArea = "_iy-2";
export var titleAreaWithHandle = "_iy-4";